import { useMemo } from "react";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { type CreateLeadsGrantsInput, createLeadsGrants } from "../configs/createLeadsGrants";
import type { LeadsCapability } from "../types/leadsCapability";

/**
 * Resolves a surface's page intent + workspace entitlements into the capability grants that gate leads
 * filters, so surfaces stay filter-agnostic (ADR-0008/0012).
 */
export const useLeadsGrants = ({
    isExcludeSectionAvailable,
    isCrmFilterAvailable,
    isCrmScopeFilterAvailable,
    isCompanyFilterAvailable,
    activeCrmIntegration,
}: CreateLeadsGrantsInput): ReadonlySet<LeadsCapability> =>
    useMemo(
        () =>
            createLeadsGrants(salesSettingsHelper, {
                isExcludeSectionAvailable,
                isCrmFilterAvailable,
                isCrmScopeFilterAvailable,
                isCompanyFilterAvailable,
                activeCrmIntegration,
            }),
        [
            isExcludeSectionAvailable,
            isCrmFilterAvailable,
            isCrmScopeFilterAvailable,
            isCompanyFilterAvailable,
            activeCrmIntegration,
        ],
    );
